import React, { useState, useEffect } from 'react';

//VISUALS
import BANKINGWEB3 from '../../assets/images/digital_banking.png';
import LOGO from '../../assets/images/logo.png';
import LOGO_BLACK from '../../assets/images/logo_black.png';

//COMPONENTS
import Menu from '../../components/menu';
import BoardHeader from '../../components/boardheader';
import { ThreeDots } from 'react-loader-spinner';

//UTILS
import UserService from '../../services/user_services';
import TokenService from '../../services/token_services';
import { EXPLORER } from '../../constants';
import { isMobile } from 'react-device-detect';

//TRANSLATION
import { useTranslation } from 'react-i18next';

const Operations = () => {
    const { t } = useTranslation();
    const [profile, setProfile] = useState({});
    const [operations, setOperations] = useState([]);
    const [beneficiaries, setBeneficiaries] = useState([]);
    const [loading, onChangeLoading] = useState(true);
    const [sortBy, setSortBy] = useState('date');
    const [sortOrder, setSortOrder] = useState('desc');

    const loadOps = async () => {
        const data = TokenService.getUser()
        setProfile(data.account)
        const bs = await UserService.getBeneficiaries()
        let benfs = {}
        for (let b of bs) {
            benfs[b.public_address.toLowerCase()] = b
        }
        setBeneficiaries(benfs)
        const ops = await UserService.getOperations()
        setOperations(ops)
        onChangeLoading(false)
    }

    useEffect(() => {
        loadOps();
        // eslint-disable-next-line
    }, []);

    const currentAddress = (profile.public_address || '').toLowerCase();

    const formatDateTime = (value) => {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`;
    };

    const shortHash = (value) => {
        if (!value) return '-';
        if (value.length <= 22) return value;
        return `${value.substring(0, 10)}...${value.substring(value.length - 8)}`;
    };

    const getAvatarStyle = (party, fallbackAddress) => ({
        backgroundImage: party ?
            party.selfie ?
                `url('data:image/${party.selfie_ext};base64,${party.selfie}')`
                :
                `url('https://api.dicebear.com/9.x/pixel-art-neutral/svg?seed=${party.user_uuid || fallbackAddress}.png')`
            : `url('https://api.dicebear.com/9.x/pixel-art-neutral/svg?seed=${fallbackAddress}.png')`
    });

    const sortedOperations = [...operations].sort((a, b) => {
        const first = sortBy === 'amount' ? Number(a.value) || 0 : new Date(a.block_time).getTime() || 0;
        const second = sortBy === 'amount' ? Number(b.value) || 0 : new Date(b.block_time).getTime() || 0;
        return sortOrder === 'asc' ? first - second : second - first;
    });

    return (
        <div className="dashboard">
            <Menu />
            <div className="right_board">
                <BoardHeader title={t('ops.operations')} />
                <div className="content">
                    <div className="data_section">
                        <div className="ops_header_row">
                            <p><strong>{t('ops.browse_ops')}</strong></p>
                            <div className="ops_sort_controls">
                                <button className={sortBy === 'date' ? 'ops_sort_btn active' : 'ops_sort_btn'} onClick={() => setSortBy('date')}>
                                    Date
                                </button>
                                <button className={sortBy === 'amount' ? 'ops_sort_btn active' : 'ops_sort_btn'} onClick={() => setSortBy('amount')}>
                                    Montant
                                </button>
                                <button className="ops_sort_btn" onClick={() => setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc')}>
                                    {sortOrder === 'asc' ? 'Asc' : 'Desc'}
                                </button>
                            </div>
                        </div>
                    </div>
                    <ThreeDots visible={loading} height="50" width="50" color="#1F90FA" radius="9" ariaLabel="three-dots-loading" />
                    {!loading &&
                        <div className="data_section">
                            <div className="dashboard_table_wrap ops_table_wrap">
                                <table className="dashboard_table ops_table">
                                    <thead>
                                        <tr>
                                            <th>Type</th>
                                            <th>{t('dashboard.created')}</th>
                                            <th>Contrepartie</th>
                                            <th>{t('dashboard.amount')}</th>
                                            <th>Tx</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sortedOperations.map(op => {
                                            const isSent = currentAddress === op.from;
                                            const isReceived = currentAddress === op.to;
                                            const counterpart = isSent ? op.to : op.from;
                                            const party = beneficiaries[counterpart] || beneficiaries[counterpart.toLowerCase()];
                                            const hasPartyName = party && party.firstname;

                                            return (
                                                <tr key={op.hash}>
                                                    <td>
                                                        <span className="cell_label">Type</span>
                                                        <span className={isSent ? 'status_badge pending' : 'status_badge'}>{isSent ? t('ops.sent') : t('ops.received')}</span>
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">{t('dashboard.created')}</span>
                                                        {formatDateTime(op.block_time)}
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">Contrepartie</span>
                                                        <div className="operation_counterparty">
                                                            {op.claim_uuid ?
                                                                <div className="select_profile">
                                                                    <div className="select_avatar" style={{ backgroundImage: `url('${LOGO_BLACK}')` }}></div>
                                                                    <div className="select_info">
                                                                        <span className="select_name">Lifise</span>
                                                                        <span className="select_email">{t('ops.offered_by')} <strong>Lifise</strong></span>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="select_profile">
                                                                    <div className="select_avatar" style={getAvatarStyle(party, counterpart)}></div>
                                                                    <div className="select_info">
                                                                        <span className="select_name">
                                                                            {hasPartyName ?
                                                                                `${party.firstname} ${party.lastname}`
                                                                                :
                                                                                `${counterpart.substring(0, 5)}...${counterpart.substring(0, 15)}`}
                                                                        </span>
                                                                        <span className="select_email">{party ? party.email_address : isSent ? t('ops.unreferenced_receiver') : t('ops.unreferenced_sender')}</span>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">{t('dashboard.amount')}</span>
                                                        <span className={isReceived ? 'ops_amount amount_in' : 'ops_amount amount_out'}>
                                                            {isReceived ? '+' : '-'} {op.value}
                                                        </span>
                                                        <img className="ops_amount_symbol" alt="CaâEuro symbol" src={isReceived ? LOGO : LOGO_BLACK} />
                                                    </td>
                                                    <td>
                                                        <span className="cell_label">Tx</span>
                                                        <span className="tx_link" onClick={() => window.open(`${EXPLORER}/tx/${op.hash}`)}>{shortHash(op.hash)}</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
                {!isMobile && <img src={BANKINGWEB3} className="visual" alt="Digital banking" />}
            </div>
        </div>
    )
};

export default Operations;